import React from 'react';
import {Button, Space} from "antd";
import {CreditCardOutlined} from "@ant-design/icons";
import {useSearchParams} from "react-router-dom";

const ConnectWalletCard = () => {
  const [searchParams] = useSearchParams();
  const cardNumber = searchParams.get('card_number');

  const handleAddToAppleWallet = () => {
    // Просто открываем .pkpass — iOS сам предложит добавить в Wallet
    window.open(`https://${process.env.REACT_APP_APP_URL}/api/v1/v1/passes/pass.com.loyalty.tablecrm/${cardNumber}`, '_blank');
  };

  return (
    <Space direction="vertical" size="middle" style={{width: '100%'}}>
      {(
        <Button
          icon={<CreditCardOutlined/>}
          type="primary"
          onClick={handleAddToAppleWallet}
          block
        >
          Добавить карту в Apple Wallet
        </Button>
      )}

    </Space>
  );
};

export default ConnectWalletCard;